/* ==========================================================================
   404 Not Found Page
   Shown when a route doesn't match any defined paths
   ========================================================================== */

import { Link, useLocation } from 'react-router-dom'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { FileQuestion } from 'lucide-react'

export function NotFound() {
  const location = useLocation()

  return (
    <div className="flex min-h-screen items-center justify-center bg-warm-beige p-4">
      <Card className="w-full max-w-md">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <FileQuestion className="h-16 w-16 text-charcoal/30" />
          </div>
          <h1 className="font-serif text-2xl text-charcoal mb-2">
            Page Not Found
          </h1>
          <p className="text-charcoal/70 mb-2">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <p className="text-sm text-charcoal/50 mb-6 font-mono">
            {location.pathname}
          </p>
          <Link to="/">
            <Button variant="primary" className="w-full">
              Go to Home
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  )
}

export default NotFound
